import Axios from "../../config/axios";
import { getDate1 } from "../../constants/defaultValues";
import { getCurrentLanguage } from "../../helpers/Utils";
import { getUnusedVoucher } from "../../redux/admin/CardInvoice/action";
class UserService {
  getOfficeUsersDropdown = async (data) => {
    return await Axios.get("/get-office-users-dropdown", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getOfficeUsersMenu= async (data) => {
    return await Axios.get("/get-office-user-menu", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  
   updateInvoiceMenu = (invoiceData) => {
    return Axios.post("/update-invoice-menu", invoiceData)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    getDspusertype = (data) => {
    return Axios.get('/get-dsp-user-type', { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    getDspUserList = async (paramdata) => {
    let currentDate = getDate1(new Date());
    paramdata = {
      ...paramdata,
      language: getCurrentLanguage(),
    };
    // console.log(paramdata);
    let params = {
      params: paramdata,
    };

    if (paramdata?.isExcel || paramdata?.isPdf) {
      params.responseType = 'arraybuffer';
    }

    return await Axios.get('/get-dsp-user-list', params)
      .then(function (response) {
        const { data: data_1 } = response;
        if (paramdata?.isExcel || paramdata?.isPdf) {
          const fileName = 'User List' + currentDate;
          const blob = new Blob([data_1], {
            type: response?.headers['content-type'],
          });
          saveAs(blob, fileName);
        } else {
          return data_1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getDspUser1 = async (data) => {
    return await Axios.get('/get-user-by-parent')
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getDspUser_1 = async (paramdata) => {
    let currentDate = getDate1(new Date());
    paramdata = {
      ...paramdata,
      language: getCurrentLanguage(),
    };
    let params = {
      params: paramdata,
    };

    if (paramdata?.isExcel || paramdata?.isPdf) {
      params.responseType = 'arraybuffer';
    }

    return await Axios.get('/get-users-list', params)
      .then(function (response) {
        const { data: data_1 } = response;
        if (paramdata?.isExcel || paramdata?.isPdf) {
          const fileName = 'User List' + currentDate;
          const blob = new Blob([data_1], {
            type: response?.headers['content-type'],
          });
          saveAs(blob, fileName);
        } else {
          console.log(data_1);
          return data_1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getInvoiceMenu = async () => {
    return await Axios.get("/get-invoice-menu")
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

}

export default new UserService();
